"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ordinal_1 = __importDefault(require("ordinal"));
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const __1 = require("../../../../");
const autosave_1 = require("../../../../hooks/autosave");
const data_1 = require("../../../../hooks/data");
const TaskPage_1 = require("../../base/TaskPage");
const Chip_1 = require("../../../components/chip/Chip");
const InlineMessage_1 = require("../../../components/inline-message/InlineMessage");
const Label_1 = require("../../../components/input/label/Label");
const merlin_select_1 = require("@travelnest/merlin.select");
const Spacer_1 = require("../../../components/spacer/Spacer");
const constants_1 = require("../../../../tasks/constants");
const validation_1 = require("../../../../hooks/validation");
const data_2 = require("../bedrooms/data");
const AmenitiesPage_1 = require("../amenities/AmenitiesPage");
const capitalize_1 = require("../../../../util/capitalize");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Heading_1 = require("../../../components/heading/Heading");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
exports.default = (props) => {
    var _a;
    // @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
    const { entityActions } = React.useContext(__1.AppContext);
    const { property, viewState, update, lastSaved, updaterError, getterError } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [propertyTypeValid, propertyTypeError] = (0, validation_1.usePropertyValidation)('property_type', property);
    const [propertySizeValid, propertySizeError] = (0, validation_1.usePropertyValidation)('property_size', property);
    const { itemTypes } = (0, data_1.useItemTypes)(entityActions);
    const renderEntranceLevelValue = (val) => {
        if (val === 0) {
            return 'Ground';
        }
        else {
            return (0, ordinal_1.default)(val);
        }
    };
    const [didEstimate, setDidEstimate] = React.useState(false);
    React.useEffect(() => {
        const estimateFloorspace = () => {
            if (!property)
                return undefined;
            const bathrooms = property.bathrooms || [];
            const bedrooms = (0, data_2.bedsToEditState)(property.beds).rooms;
            const raw = (Object.keys(bedrooms).length * 17.152) +
                (bathrooms.length * 10.000) +
                (bathrooms.filter((b) => b.toilet_type !== 'none').length * 8.596) +
                +((property.capacity || 0) * 0.0099);
            return Math.ceil(raw / 5) * 5;
        };
        if (!!property && (property.property_size === undefined || property.property_size <= 1)) {
            const estimate = estimateFloorspace();
            if (estimate !== undefined) {
                setDidEstimate(true);
                update({ property_size: estimate });
            }
        }
    }, []);
    /*
    Functions hasAmenity and amenityChipTap apply to a Property Composition option that mirror an amenity.
    Ex: when choosing "Private entrance door" as part of the Property Composition, the amenity Private Entrance also updates.
    */
    const hasAmenity = (amenityName) => {
        const amenity = ((property === null || property === void 0 ? void 0 : property.amenities) || []).find((a) => a.amenity_type === amenityName);
        return amenity !== undefined && amenity.is_present === true;
    };
    const amenityChipTap = (chipID, selected) => {
        if (!property)
            return;
        const name = chipID.replace('_', ' ');
        const amenityInfo = { name, selected };
        const amenities = (0, AmenitiesPage_1.updateAmenityInList)(property.amenities, property.id, amenityInfo);
        update({ amenities });
    };
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.PROPERTY_COMPOSITION, property: property, viewState: viewState, lastSaved: lastSaved, getterError: getterError, updaterError: updaterError },
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(HorizontalRule_1.HorizontalRule, null),
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(merlin_select_1.Select, { label: "Property type", hintText: "Which of these property types is the closest match to your property?", id: "property_type", value: (property === null || property === void 0 ? void 0 : property.property_type) || '', onChange: (e) => update({ property_type: e.target.value }) },
                        React.createElement("option", { value: '' }, "Please select ..."), (_a = itemTypes === null || itemTypes === void 0 ? void 0 : itemTypes.property_types) === null || _a === void 0 ? void 0 :
                        _a.map(({ name }, i) => React.createElement("option", { key: i, value: name }, (0, capitalize_1.capitalize)(name)))),
                    React.createElement(Spacer_1.Spacer, null),
                    !propertyTypeValid && React.createElement(React.Fragment, null,
                        React.createElement(InlineMessage_1.InlineError, { text: propertyTypeError }),
                        React.createElement(Spacer_1.Spacer, null)),
                    React.createElement(Heading_1.HeadingSmall, null, "Property layout"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                    React.createElement(Label_1.ParagraphLabel, { htmlFor: "floor_space" }, "What is the approximate total internal floor space of your property?"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    didEstimate && (React.createElement(React.Fragment, null,
                        React.createElement(InlineMessage_1.InlineTip, { text: "We've estimated this for you" }),
                        React.createElement(Spacer_1.Spacer, { spacing: "small" }))),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "floor_space", value: property === null || property === void 0 ? void 0 : property.property_size, onClick: (v) => update({ property_size: v }), step: 5, valueFormatter: (value) => `${value} m2`, maxValue: Number.MAX_SAFE_INTEGER }),
                    React.createElement(Spacer_1.Spacer, null),
                    !propertySizeValid && React.createElement(React.Fragment, null,
                        React.createElement(InlineMessage_1.InlineError, { text: propertySizeError }),
                        React.createElement(Spacer_1.Spacer, null)),
                    React.createElement(Label_1.ParagraphLabel, { htmlFor: "floor_count" }, "How many floors does your property have?"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "floor_count", value: (property === null || property === void 0 ? void 0 : property.number_of_floors) || 1, minValue: 1, onClick: (v) => update({ number_of_floors: v }), valueFormatter: (value) => `${value} ${value > 1 ? 'floors' : 'floor'}` }),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(Label_1.ParagraphLabel, { htmlFor: "floor_entrance" }, "On which floor is the entrance of your property located?"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "floor_entrance", onClick: (v) => update({ entrance_floor: v }), valueFormatter: renderEntranceLevelValue, value: (property === null || property === void 0 ? void 0 : property.entrance_floor) || 0, minValue: 0 }),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    React.createElement(Heading_1.HeadingSmall, null, "Access and security"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: "yellow", id: "wheelchair-access-info-composition-page", text: "Please select the wheelchair access feature only if you meet all of the standards as required by applicable law.", widthOverride: "100%" }),
                    React.createElement(Chip_1.ChipQuestion, { question: "Which of the following features does your property have?" },
                        React.createElement(Chip_1.Chip, { selected: hasAmenity('private entrance'), onChange: amenityChipTap, id: "private_entrance", text: "Private entrance door" }),
                        React.createElement(Chip_1.Chip, { selected: (property === null || property === void 0 ? void 0 : property.has_elevator) || false, onChange: (_, selected) => update({ has_elevator: selected }), id: "elevator", text: "Elevator" }),
                        React.createElement(Chip_1.Chip, { selected: hasAmenity('wheelchair access'), onChange: amenityChipTap, id: "wheelchair_access", text: "Wheelchair access" })))))));
};
//# sourceMappingURL=CompositionPage.js.map